function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64">
      <path
        fill="#0044F0"
        fillRule="evenodd"
        d="M47.297 16.123c4.553 3.514 8.43 8.662 11.213 15.101.208.489.208 1.06 0 1.526C52.943 45.627 43.03 53.333 32 53.333h-.026c-11.005 0-20.917-7.706-26.485-20.583a1.94 1.94 0 0 1 0-1.526c5.568-12.88 15.48-20.557 26.485-20.557H32c5.515 0 10.744 1.913 15.297 5.456M21.593 32c0 5.689 4.657 10.318 10.407 10.318 5.723 0 10.38-4.63 10.38-10.318 0-5.715-4.657-10.343-10.38-10.343-5.75 0-10.407 4.628-10.407 10.343"
        clipRule="evenodd"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        d="M38.482 31.992c0 3.542-2.914 6.438-6.478 6.438-3.59 0-6.504-2.896-6.504-6.438 0-.44.052-.851.13-1.265h.13a5.325 5.325 0 0 0 5.333-5.122c.287-.05.599-.078.911-.078 3.564 0 6.478 2.896 6.478 6.465"
      ></path>
    </svg>
  );
}

export default Icon;
